import _anObject from "../internals/an-object";
import _ordinaryToPrimitive from "../internals/ordinary-to-primitive";
var exports = {};
var anObject = _anObject;
var ordinaryToPrimitive = _ordinaryToPrimitive;
var $TypeError = TypeError;

// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
exports = function (hint) {
  anObject(this);
  if (hint === "string" || hint === "default") hint = "string";else if (hint !== "number") throw new $TypeError("Incorrect hint");
  return ordinaryToPrimitive(this, hint);
};
export default exports;